import { FunctionComponent, useState } from "react";
import { Link, NavLink } from "react-router-dom";

interface HeaderProps {}

const Header: FunctionComponent<HeaderProps> = () => {
  const [hambState, setHambState] = useState<boolean>(false);
  function handleHamburguerClick() {
    if (hambState) {
      setHambState(false);
    } else {
      setHambState(true);
    }
  }
  function handleClick() {
    let viewport_width = window.innerWidth;
    let viewport_height = window.innerHeight;
    if (viewport_width <= 1020) {
      handleHamburguerClick();
    }
  }
  return (
    <header>
      <nav>
        <div className="nav_left">
          <div className="logo_container no-select">
            <NavLink to="/">
              <img src="./assets/images/logo.webp" alt="logo" className="logo" />
            </NavLink>
          </div>
        </div>
        <div className="nav_right">
          <ul className={hambState ? "items_container active" : "items_container"}>
            <li
              onClick={() => {
                handleClick();
              }}
            >
              <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
                Inicio
              </NavLink>
            </li>
            <li
              onClick={() => {
                handleClick();
              }}
            >
              <NavLink to="/quienes-somos">Quienes somos</NavLink>
            </li>
            <li
              onClick={() => {
                handleClick();
              }}
            >
              <NavLink to="/nuestros-trabajos">Nuestros trabajos</NavLink>
            </li>
            <li
              onClick={() => {
                handleClick();
              }}
            >
              <NavLink to="/contacto">Contacto</NavLink>
            </li>
          </ul>
          <div className="hamburguer" onClick={handleHamburguerClick}>
            <i className="fa fa-bars" aria-hidden="true"></i>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
